import { useState } from 'react';
import { useSwipeable } from 'react-swipeable';

export const useSwipe = (openCloseToggle: () => void) => {
	const [isFullHeight, setIsFullHeight] = useState(false);

	const handleSwipeUp = (): void => {
		if (isFullHeight) {
			return;
		}
		setIsFullHeight(true);
	};

	const handleSwipeDown = (): void => {
		if (isFullHeight) {
			setIsFullHeight(false);
		} else {
			openCloseToggle();
		}
	};

	const handlers = useSwipeable({
		onSwipedUp: () => handleSwipeUp(),
		onSwipedDown: () => handleSwipeDown(),
		trackMouse: true,
	});

	return {
		isFullHeight,
		handlers,
	};
};
